import React, { PropTypes } from "react";
import { Field, reduxForm } from "redux-form";

import { SelectInput } from "../../../../common/form";

const BillingPeriodFilter = (props) => {
  const { onChange, options } = props;

  return (
    <div className="datatable-filter bp-filter-width">
      <Field
        id="billingPeriodFilter"
        name="billingPeriodFilter"
        component={SelectInput}
        options={options}
        props={{ onChange }}
        sortOptions={false}
      />
    </div>
  );
};

BillingPeriodFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
};

export default reduxForm({
  form: "billingPeriodFilter",
  enableReinitialize: true
})(BillingPeriodFilter);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/BillingPeriodFilter.js